"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bowser_1 = __importDefault(require("bowser"));
const loglevel_1 = __importDefault(require("loglevel"));
const config_js_1 = require("../config/config.js");
require('get-float-time-domain-data');
/**
 * @ignore
 */
class AudioProcess {
    constructor(context, stream, isLocal = false, audio3D = true, processCb) {
        this.stream = stream;
        this.processCb = processCb;
        this.isLocal = isLocal;
        this.audio3D = audio3D;
        this.connected = false;
        this.level = 0;
        this.context = context;
        // Accepted dB range 0 - 36. Everything below 0 will result in audio level equal 0,
        // everything over 36 will result in audio level equal 1
        this.dbrange = 36;
        this.dblimit = 0;
        this.x = 0.0;
        this.y = 0.5;
        this.savedGain = 1.0;
    }
    // Connecting to an audio source and creating an instance of a web audio analyzer
    connect() {
        //this.source = this.context.createMediaElementSource(elem);
        this.source = this.context.createMediaStreamSource(this.stream);
        this.analyserNode = this.context.createAnalyser();
        this.analyserNode.smoothingTimeConstants = 1;
        this.analyserNode.fftSize = 256;
        this.stereoPanner = this.context.createPanner();
        this.stereoPanner.channelCount = 1;
        this.stereoPanner.setOrientation(0, 0, 0);
        this.stereoPanner.setPosition(this.x, 0, -this.y);
        if (bowser_1.default.firefox && bowser_1.default.windows) {
            this.stereoPanner.panningModel = 'equalpower';
        }
        else {
            this.stereoPanner.panningModel = 'HRTF';
        }
        this.stereoPanner.distanceModel = config_js_1.audioSettings.distanceModel;
        this.stereoPanner.refDistance = config_js_1.audioSettings.refDistance;
        this.stereoPanner.maxDistance = config_js_1.audioSettings.maxDistance;
        this.stereoPanner.rolloffFactor = config_js_1.audioSettings.rollOffFactor;
        this.gainNode = this.context.createGain();
        this.gainNode.gain.value = config_js_1.audioSettings.gain;
        //this.stereoPanner.pan.value = 0; // default value
        this.data = new Uint8Array(this.analyserNode.fftSize);
        // connecting source and analyzer ndoes
        if (this.isLocal && this.processCb) {
            // An external callback for processing audio has been provided
            this.scriptProcessorNode = this.context.createScriptProcessor(8192, 2, 2);
            this.source.connect(this.scriptProcessorNode);
            this.scriptProcessorNode.connect(this.analyserNode);
            this.scriptProcessorNode.onaudioprocess = this.processCb;
        }
        else {
            this.source.connect(this.analyserNode);
        }
        if (!this.isLocal && this.audio3D) {
            this.analyserNode.connect(this.stereoPanner);
            this.stereoPanner.connect(this.gainNode);
            this.gainNode.connect(this.context.destination);
        }
        // if (!this.isLocal) {
        //   if (this.audio3D) {
        //       this.analyserNode.connect(this.stereoPanner);
        //       this.stereoPanner.connect(this.gainNode);
        //       this.gainNode.connect(this.context.destination);
        //   }
        //   else if (!browser.chrome) {
        //       this.analyserNode.connect(this.gainNode);
        //       this.gainNode.connect(this.context.destination);
        //   }
        // }
        this.connected = true;
    }
    disconnect() {
        this.stereoPanner.disconnect();
        this.analyserNode.disconnect();
        this.gainNode.disconnect();
    }
    update() {
        if (this.connected) {
            this.analyserNode.getByteTimeDomainData(this.data);
            let rms = this.calculateRms(this.data);
            let decibels = this.toDb(rms);
            this.level = this.db2vu(decibels);
        }
        else {
            this.level = 0;
        }
    }
    calculateRms(samples) {
        let power = 0;
        samples.forEach((sample) => {
            //because data i in form of 8-bit unsigned integers (range from 0 to 255), we need to normalise the samples to the baseline of 127
            let normalized = sample - 127;
            power += normalized * normalized;
        });
        return Math.sqrt(power / samples.length);
    }
    toDb(sample) {
        return 20.0 * Math.log10(sample);
    }
    db2vu(decibels) {
        if (decibels === -Infinity || decibels < this.dblimit)
            return 0;
        //Normalize value to be in between 0 and 1;
        let normDB = decibels / this.dbrange;
        let scaled = Math.PI / 2 + (Math.PI / 2) * normDB;
        //Apply scale
        let normalized = 1 - Math.sin(scaled);
        return normalized > 1 ? 1 : normalized;
    }
    mute(isMuted) {
        let gain = this.savedGain;
        if (isMuted && this.gainNode.gain.value !== 0.0) {
            this.savedGain = this.gainNode.gain.value;
            gain = 0.0;
        }
        this.gainNode.gain.value = gain;
    }
    toggleMute() {
        if (this.gainNode.gain.value > 0.0) {
            this.savedGain = this.gainNode.gain.value;
            this.gainNode.gain.value = 0.0;
        }
        else {
            this.gainNode.gain.value = this.savedGain;
        }
        return this.gainNode.gain.value <= 0.0;
    }
    setGain(gain) {
        this.gainNode.gain.value = gain;
    }
    setPosition(x, y) {
        // Clamping value to [-1, 1]
        //var pan = Math.max(-1, x);
        //pan = Math.min(1, x);
        if (isFinite(x) && isFinite(y)) {
            this.x = x;
            this.y = Math.max(config_js_1.audioSettings.refDistance, Math.min(1, y)); // Need to be the same othewise firefox is going wired
            this.stereoPanner.setPosition(this.x, 0, this.y);
        }
        else {
            loglevel_1.default.debug('setPosition received non finite position');
        }
    }
    getLevel() {
        return this.level;
    }
    setLevel(level) {
        this.level = level;
    }
}
exports.default = AudioProcess;
